import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";

import { clsx } from "../../utils/clsx";

type ModalLayoutProps<E extends ElementType> = {
  as?: E;
  children?: ReactNode;
  className?: string;
} & ComponentPropsWithoutRef<E>;

export const ModalLayout = <E extends ElementType>({ as, children, className, ...props }: ModalLayoutProps<E>) => {
  const AsElement = as ?? "div";

  return (
    <AsElement
      {...props}
      className={clsx(
        "grid h-full w-screen grid-rows-[auto_1fr_auto] [grid-template-areas:'header'_'content'_'actions'] sm:max-h-[calc(100vh-64px)] sm:w-fit",
        className,
      )}
    >
      {children}
    </AsElement>
  );
};
